import { format, parseISO } from 'date-fns';
import pt from 'date-fns/locale/pt';

export default function formatTime(date) {
  return format(parseISO(date), 'HH:mm', {
    locale: pt,
  });
}
